import PencilIcon from "../../assets/icons-redesign/pencil.svg?react";

export const FeedbackEmptyState = () => {
  return (
    <div className="flex flex-col items-center border border-gray-light-10 px-3 py-6 gap-8 mx-6 mb-6 rounded-xl">
      <div
        className="flex flex-col items-center justify-center shrink bg-gray-200 border border-gray-light-10 border-dashed gap-2 p-3 rounded-lg text-xs text-gray-600 -rotate-6"
      >
        <PencilIcon fill="#50555C" />
        Anything to share?
      </div>
      <div className="flex flex-col gap-1 text-center">
        <div className="font-light text-xl">
          No Responses
        </div>
        <div className="text-sm text-gray-600">
          Sorry! There were no written responses to this question from the user base.
        </div>
      </div>
    </div>
  );
};

export default FeedbackEmptyState;
